var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4985 0.632821C10.6583 1.03777 10.5378 1.49961 10.2005 1.77484C8.56256 3.11126 7.51946 5.14253 7.51946 7.41822C7.51946 11.4384 10.7785 14.6974 14.7987 14.6974C15.7983 14.6974 16.7485 14.4965 17.613 14.1337C18.0149 13.9651 18.4798 14.0762 18.7621 14.4084C19.0443 14.7407 19.0788 15.2175 18.8473 15.5868C17.0457 18.4618 13.8465 20.377 10.1991 20.377C4.56631 20.377 0 15.8107 0 10.1779C0 4.77969 4.19317 0.361738 9.50077 0.00230078C9.93514 -0.0271149 10.3386 0.227874 10.4985 0.632821ZM6.79825 2.71495C3.96757 4.00708 2 6.86294 2 10.1779C2 14.7061 5.67088 18.377 10.1991 18.377C12.0732 18.377 13.8008 17.7486 15.1823 16.6896C15.0551 16.6948 14.9272 16.6974 14.7987 16.6974C9.67391 16.6974 5.51946 12.543 5.51946 7.41822C5.51946 5.70172 5.98594 4.0939 6.79825 2.71495Z",
    fill: "#392A93"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.044367241665ea18409ff63217c89fdd.svg";
export { ForwardRef as ReactComponent };